import { Box, Tooltip, useTheme } from "@mui/material";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { Q3DButton } from "../../Parts/Q3DButton";
import {
  PollingContext,
  ProcessIds,
  ProjectDetailContext,
  UseSnackbarContext,
} from "../Interfaces/ProjectDetailInterfaces";
import axios from "axios";
import { Common } from "../../../../common/src";
import HelmContext from "../Contexts/HelmContext";
import { config } from "../../../config/config";
import { ECoordinateTransformMode } from "../../config/componentsConfig";

type Props = {};

export const HelmTransform = (props: Props) => {
  const { openError, openWarning, openSuccess } =
    useContext(UseSnackbarContext);
  const {
    currentHelmTab,
    coordinatePoints,
    referencePoints,
    fetchReferencePoints,
  } = useContext(HelmContext);
  const { projectDetail, getProjectDetail } = useContext(ProjectDetailContext);
  const [isHelmertTransforming, setIsHelmertTransforming] =
    useState<boolean>(false); // While helmart transform
  const { processIds, updateProcessIds } = useContext(PollingContext);
  const theme = useTheme();

  // Exec, ヘルマート変換呼び出し
  const execHelmertTransform = async () => {
    setIsHelmertTransforming(true);
    // setIsTransformFetching(true);
    // API呼び出しPara宣言
    const originalXVals: number[] = [];
    const originalYVals: number[] = [];
    const originalZVals: number[] = [];
    const correspondingXVals: number[] = [];
    const correspondingYVals: number[] = [];
    const correspondingZVals: number[] = [];

    // API呼び出しPara作成
    referencePoints.forEach((data) => {
      originalXVals.push(data.x);
      originalYVals.push(data.y);
      originalZVals.push(data.z);
      if (data.correspondingPointId !== undefined) {
        const row_data = coordinatePoints.find(
          (r) => r.id === data.correspondingPointId
        );
        if (row_data !== undefined) {
          correspondingXVals.push(row_data?.x);
          correspondingYVals.push(row_data?.y);
          correspondingZVals.push(row_data?.z);
        }
      }
    });
    const ref_points_before: Common.PointsHelmert = {
      x_vals: originalXVals,
      y_vals: originalYVals,
      z_vals: originalZVals,
    };
    const ref_points_after: Common.PointsHelmert = {
      x_vals: correspondingXVals,
      y_vals: correspondingYVals,
      z_vals: correspondingZVals,
    };
    const input_data: Common.helmert = {
      ref_pt_before: ref_points_before,
      ref_pt_after: ref_points_after,
      size: referencePoints.length,
      id_vals: referencePoints.map((r) => r.id),
    };

    // API呼び出し、DBに更新
    await axios
      .post(
        `${config.serverHost}/api/v1/project/${projectDetail?.id}/helmert`,
        input_data,
        { withCredentials: true }
      )
      .then((res) => {
        // 画面自動リロードさせる
        // pointProps.setInitDone(false);
        // fetchReferencePoints(projectDetail?.id);
        openSuccess(t("START_COORD_TRANSFOR"));

        updateProcessIds({
          sfm: res.data.process_id,
          helmert: processIds.helmert,
        } as ProcessIds);
      })
      .catch((err) => {
        if (err.response.status === 504) {
          openWarning(t("PLS_RELOAD"));
        } else if (err.response.status === 429) {
          const resStatus = err.response.data as Common.ProcessingStatus;
          if (resStatus.helmert_transformation) {
            openError(t("HELMERT_TRANSFORM") + t("PROCESSING_STATUS_ERROR"));
          } else if (resStatus.coordinate_transformation) {
            openError(t("COORDINATE_PROCESS") + t("PROCESSING_STATUS_ERROR"));
          } else if (resStatus.point_splitting) {
            openError(
              t("POINT_GROUP_SEGMENTATION") + t("PROCESSING_STATUS_ERROR")
            );
          } else if (resStatus.remove) {
            openError(t("SIMPLE_POINT_REMOVAL") + t("PROCESSING_STATUS_ERROR"));
          } else if (resStatus.txt_conversion) {
            openError(t("TEXT_CONVERSION") + t("PROCESSING_STATUS_ERROR"));
          }
        } else {
          openError(t("ERROR"));
        }
      })
      .finally(() => {
        // setIsTransformFetching(false);
        getProjectDetail(false);
        setIsHelmertTransforming(false);
      });
  };

  const disableHelmertTransferButton = () => {
    return (
      referencePoints.length < 3 ||
      referencePoints.some((data) => !data.correspondingPointId)
    );
  };

  return (
    <Tooltip
      title={<span className="tool-tip-cal">{t("COORDINATE_TRANSFOR")}</span>}
      placement="top"
      arrow
    >
      <span>
        <Q3DButton
          text={t("COORDINATE_TRANSFOR")}
          onClick={execHelmertTransform}
          loading={isHelmertTransforming}
          disabled={disableHelmertTransferButton()}
          height={"36px"}
          sx={{
            background: theme.palette.base.ymdBackground,
          }}
        />
      </span>
    </Tooltip>
  );
};
